var React = require('react');

function Logomark (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.0146169 8.91812H20.9807L16.4933 13.4055H0.0146169V20.0946H9.80427L0 29.8988L2.103 32L11.9055 22.1957V31.9854H18.5945V15.5067L23.0545 11.0485V31.9854H31.9726V0H0.0146169V8.91812Z","fill":"white"}));
}

Logomark.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Logomark;

Logomark.default = Logomark;
